;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('LedgerErrorController', LedgerErrorController)

  LedgerErrorController.$inject = [
    // Angular
    '$uibModalInstance',

    // Resolve
    'errors'

  ]

  function LedgerErrorController (
    // Angular
    $uibModalInstance,

    // Resolve
    errors

  ) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        errors: errors,

        // Public Method
        cancel: cancel,
        accept: accept
      })

      init()
    }

    function init () {
      self.vatErrors = _.filter(self.errors, function (elt) {
        return elt.type === 'MISSING_VAT_ACCOUNT'
      })
      self.typeErrors = _.filter(self.errors, function (elt) {
        return elt.type === 'MISSING_LINE_ACCOUNT'
      })
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function accept () {
      $uibModalInstance.close(true)
    }
  }
})(window.angular, window._)
